/**
 * @file
 * Behaviors for the Sticky Filter.
 */

!((Drupal) => {
  'use strict';

  /**
   * Setup and attach the stickyFilter.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.stickyFilter= {
    attach: function (context) {
      if (window.IntersectionObserver) {
        const headerEl = document.querySelector('.sticky-filter', context);
        const sentinalEl = document.querySelector('.sticky-filter__observer');
        const filterToggle = document
          .querySelector('.sticky-filter__toggle', context);

        const handler = (entries) => {
          // entries is an array of observed dom nodes
          // we're only interested in the first one at [0]
          // because that's our .sentinal node.
          // Here observe whether or not that node is in the viewport
          if (!entries[0].isIntersecting) {
            headerEl.classList
              .add('sticky-filter__stuck', 'sticky-filter__closed');
          }
          else {
            headerEl.classList
              .remove('sticky-filter__stuck' , 'sticky-filter__closed');
          }
        };

        // create the observer
        const observer = new window.IntersectionObserver(handler);

        // give the observer some dom nodes to keep an eye on
        observer.observe(sentinalEl);

        //Click toggle handler
        filterToggle.addEventListener('click', event => {
          if (headerEl.classList.contains('sticky-filter__closed')) {
            headerEl.classList.remove('sticky-filter__closed');
          }
          else {
            headerEl.classList.add('sticky-filter__closed');
          }
        });
      }
    },
  };
})(Drupal, jQuery);
